/*
 * @Description: Description
 * @Autor: Chen
 * @Date: 2021-07-06 08:48:03
 * @LastEditors: snzo.chen
 * @LastEditTime: 2023-06-13 15:06:12
 */
const MenuConfig = [
  {
    level: 1,
    title: '首页',
    breadcrumb: '首页',
    icon: '',
    url: '/',
    open: false,
    selected: false,
    disabled: false,
    isShow: true,
  },
  {
    level: 1,
    title: '关于联盟',
    breadcrumb: '关于联盟',
    icon: '',
    open: false,
    selected: false,
    disabled: true,
    isShow: true,
    children: [
      {
        level: 2,
        title: '联盟简介',
        breadcrumb: '联盟简介',
        icon: '',
        url: '/alone',
        open: false,
        selected: false,
        disabled: false,
        typeId: 6814,
        isShow: true,
      },
      {
        level: 2,
        title: '联盟章程',
        breadcrumb: '联盟章程',
        icon: '',
        url: '/alone',
        open: false,
        selected: false,
        disabled: false,
        typeId: 6817,
        isShow: true,
      },
      {
        level: 2,
        title: '组织机构',
        breadcrumb: '组织机构',
        icon: '',
        url: '/alone',
        open: false,
        selected: false,
        disabled: false,
        typeId: 6816,
        isShow: true,
      },
      // {
      //   level: 2,
      //   title: '部门职能',
      //   breadcrumb: '部门职能',
      //   icon: '',
      //   url: '/alone',
      //   open: false,
      //   selected: false,
      //   disabled: false,
      //   typeId: 31189,
      //   isShow: true
      // },
      {
        level: 2,
        title: '政策法规',
        breadcrumb: '政策法规',
        icon: '',
        url: '/news/list',
        open: false,
        selected: false,
        disabled: false,
        typeId: 4,
        isShow: true,
      },
      {
        level: 2,
        title: '大家关怀',
        breadcrumb: '大家关怀',
        icon: '',
        url: '/care/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: '40009:5',
        isShow: true,
      },
      {
        level: 2,
        title: '联系我们',
        breadcrumb: '联系我们',
        icon: '',
        url: '/alone',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40073,
        isShow: true,
      },
      {
        level: 2,
        title: '机器人定义',
        breadcrumb: '机器人定义',
        icon: '',
        url: '/alone',
        open: false,
        selected: false,
        disabled: false,
        typeId: 31333,
        isShow: false,
      },
    ],
  },
  {
    level: 1,
    title: '资讯公告',
    breadcrumb: '资讯公告',
    icon: '',
    open: false,
    selected: false,
    disabled: true,
    isShow: true,
    children: [
      {
        level: 2,
        title: '资讯',
        breadcrumb: '资讯',
        icon: '',
        url: '/news/list',
        open: false,
        selected: false,
        disabled: false,
        typeId: 2,
        isShow: true,
      },
      {
        level: 2,
        title: '公告',
        breadcrumb: '公告',
        icon: '',
        url: '/news/list',
        open: false,
        selected: false,
        disabled: false,
        typeId: 3,
        isShow: true,
      },
    ],
  },
  // {
  //   level: 1,
  //   title: '大家关怀',
  //   breadcrumb: '大家关怀',
  //   icon: '',
  //   url: '/care/index',
  //   open: false,
  //   selected: false,
  //   disabled: false,
  //   typeId: '40009:5',
  //   isShow: true,
  // },

  {
    level: 1,
    title: '教育教学',
    breadcrumb: '教育教学',
    icon: '',
    url: '/education/index',
    open: false,
    selected: false,
    disabled: false,
    typeId: 40012,
    isShow: true,
    hideChildren: true,
    children: [
      {
        level: 2,
        title: '体育课程',
        breadcrumb: '体育课程 Physical Education Courses',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40016,
        isShow: false,
      },
      {
        level: 2,
        title: '教育课程',
        breadcrumb: '教育课程 Educational Course',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40018,
        isShow: false,
      },
      {
        level: 2,
        title: '教材器材',
        breadcrumb: '教材器材 Teaching Materials and Equipment',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40022,
        isShow: false,
      },
      {
        level: 2,
        title: '计算机编程',
        breadcrumb: '计算机编程 Computer Programming',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40026,
        isShow: false,
      },
      {
        level: 2,
        title: '交流外语',
        breadcrumb: '交流外语 Foreign Languages for International Exchange',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40029,
        isShow: false,
      },
      {
        level: 2,
        title: '实践基地',
        breadcrumb: '实践基地 Practice Base',
        icon: '',
        url: '/education/index',
        open: false,
        selected: false,
        disabled: false,
        typeId: 17,
        isShow: false,
      },
      {
        level: 2,
        title: '教材',
        breadcrumb: '教材 Teaching Materials',
        icon: '',
        url: '/education/jc',
        open: false,
        selected: false,
        disabled: false,
        typeId: 17,
        isShow: false,
      },
      {
        level: 2,
        title: '器材',
        breadcrumb: '器材 Equipment',
        icon: '',
        url: '/education/qc',
        open: false,
        selected: false,
        disabled: false,
        typeId: 17,
        isShow: false,
      },
    ],
  },
  {
    level: 1,
    title: '赛事活动',
    breadcrumb: '赛事活动',
    icon: '',
    url: '/match/notice',
    open: false,
    selected: false,
    disabled: false,
    typeId: 40069,
    isShow: true,
    // children: [
    //   {
    //     level: 2,
    //     title: '赛事信息',
    //     breadcrumb: '赛事信息',
    //     icon: '',
    //     url: '/match/notice',
    //     open: false,
    //     selected: false,
    //     disabled: false,
    //     typeId: 40069,
    //     isShow: true
    //   },
    //   {
    //     level: 2,
    //     title: '报名参赛',
    //     breadcrumb: '报名参赛',
    //     icon: '',
    //     url: '/match/intro',
    //     open: false,
    //     selected: false,
    //     disabled: false,
    //     typeId: 40070,
    //     isShow: true
    //   },
    //   {
    //     level: 2,
    //     title: '精彩瞬间',
    //     breadcrumb: '精彩瞬间 Wonderful Moment',
    //     icon: '',
    //     open: false,
    //     selected: false,
    //     disabled: false,
    //     isShow: false
    //   }
    // ]
  },
  {
    level: 1,
    title: '交流活动',
    breadcrumb: '交流活动',
    icon: '',
    url: '/exchange/process',
    open: false,
    selected: false,
    disabled: false,
    isShow: true,
    children: [
      {
        level: 2,
        title: '交流历程',
        breadcrumb: '交流历程',
        icon: '',
        url: 'process',
        open: false,
        selected: false,
        disabled: false,
        typeId: '40033',
        isShow: false,
      },
      {
        level: 2,
        title: '交流学习',
        breadcrumb: '交流学习',
        icon: '',
        url: '/exchange/study',
        open: false,
        selected: false,
        disabled: false,
        typeId: 25,
        isShow: false,
      },
      {
        level: 2,
        title: '出国研修',
        enTitle: 'Advance Study and Training Abroad',
        breadcrumb: '出国研修',
        icon: '',
        url: '/exchange/advance',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40034,
        isShow: false,
      },
      {
        level: 2,
        title: '长期留学',
        enTitle: 'Long Term Study Abroad',
        breadcrumb: '长期留学',
        icon: '',
        url: '/exchange/term',
        open: false,
        selected: false,
        disabled: false,
        typeId: 40035,
        isShow: false,
      },
      {
        level: 2,
        title: '交流成果',
        enTitle: 'Exchange Achievements',
        breadcrumb: '交流成果',
        icon: '',
        url: '/exchange/achievements',
        open: false,
        selected: false,
        disabled: false,
        typeId: 7,
        isShow: false,
      },
    ],
  },
  {
    level: 1,
    title: '评价认证',
    breadcrumb: '评价认证',
    icon: '',
    url: '',
    outUrl: 'http://test.cqesa.com/#/home',
    open: false,
    selected: false,
    disabled: false,
    typeId: 10,
    isShow: true,
  },
  {
    level: 1,
    title: '学分银行',
    breadcrumb: '学分银行',
    icon: '',
    url: '/creditBank/info',
    outUrl: '',
    open: false,
    selected: false,
    disabled: false,
    isShow: false,
  },
  {
    level: 1,
    title: '联系我们',
    breadcrumb: '联系我们',
    icon: '',
    url: '/alone',
    open: false,
    selected: false,
    disabled: false,
    typeId: 40073,
    isShow: false,
  },
  {
    level: 1,
    title: '专栏',
    breadcrumb: '专栏',
    icon: '',
    open: false,
    selected: false,
    disabled: true,
    isShow: false,
    children: [
      {
        level: 2,
        title: '学校作品',
        breadcrumb: '学校作品',
        icon: '',
        url: '',
        open: false,
        selected: false,
        disabled: false,
        typeId: '40040:1',
        isShow: false,
      },
      {
        level: 2,
        title: '获奖作品',
        breadcrumb: '获奖作品',
        icon: '',
        url: '',
        open: false,
        selected: false,
        disabled: false,
        typeId: '40042-2',
        isShow: false,
      },
      {
        level: 2,
        title: '中华青少年',
        breadcrumb: '中华青少年',
        icon: '',
        url: '',
        open: false,
        selected: false,
        disabled: false,
        typeId: '40044-3',
        isShow: false,
      },
    ],
  },
  {
    level: 1,
    title: '专题',
    breadcrumb: '专题',
    icon: '',
    open: false,
    selected: false,
    disabled: true,
    isShow: false,
    children: [
      {
        level: 2,
        title: '教育',
        breadcrumb: '教育',
        icon: 'assets/images/newCqesa/btn_topic_01.jpg',
        url: '/topic/education/list',
        open: false,
        selected: false,
        disabled: true,
        typeId: '40048:27',
        isShow: false,
      },
      {
        level: 2,
        title: '赛事',
        breadcrumb: '赛事',
        icon: 'assets/images/newCqesa/btn_topic_02.png',
        url: '/topic/competition',
        open: false,
        selected: false,
        disabled: true,
        typeId: '40051:28',
        isShow: false,
      },
      {
        level: 2,
        title: '交流',
        breadcrumb: '交流',
        icon: 'assets/images/newCqesa/btn_topic_03.png',
        url: '/topic/exchange',
        open: false,
        selected: false,
        disabled: true,
        typeId: '40052:29',
        isShow: false,
      },
      // {
      //   level: 2,
      //   title: '大赛小推手',
      //   breadcrumb: '大赛小推手 Competition Promoter',
      //   icon: 'assets/images/newCqesa/btn_topic_04.jpg',
      //   url: '/topic/promoter',
      //   open: false,
      //   selected: false,
      //   disabled: true,
      //   typeId: 40053,
      //   isShow: false
      // }
    ],
  },
  {
    level: 1,
    title: '大赛小推手',
    breadcrumb: '大赛小推手',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    isShow: false,
    children: [
      {
        level: 2,
        title: '培养专才系列文章',
        breadcrumb: '培养专才系列文章',
        icon: '',
        url: '/news/list',
        open: false,
        selected: false,
        disabled: false,
        typeId: 8,
        isShow: false,
      },
      {
        level: 2,
        title: '原创内容',
        breadcrumb: '原创内容',
        icon: '',
        url: '/news/list',
        open: false,
        selected: false,
        disabled: false,
        typeId: 9,
        isShow: false,
      },
      {
        level: 2,
        title: '金句一百 句句精彩',
        breadcrumb: '金句一百 句句精彩',
        icon: '',
        open: false,
        selected: false,
        disabled: false,
        typeId: 9,
        isShow: false,
      },
    ],
  },
  {
    level: 1,
    title: '“东安杯”全国青少年机器人创新挑战赛',
    breadcrumb: '“东安杯”全国青少年机器人创新挑战赛',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    typeId: 2,
    isShow: false,
  },
  {
    level: 1,
    title: '第一届青少年全球论坛“疫情下的我”',
    breadcrumb: '第一届青少年全球论坛“疫情下的我”',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    typeId: 2,
    isShow: false,
  },
  {
    level: 1,
    title: '联盟成员学校',
    breadcrumb: '联盟成员学校',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    typeId: 2,
    isShow: false,
  },
  {
    level: 1,
    title: '全国学校体育联盟（机器人运动）常务理事单位',
    breadcrumb: '全国学校体育联盟（机器人运动）常务理事单位',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    typeId: 239,
    isShow: false,
  },
  {
    level: 1,
    title: '全国学校体育联盟（机器人运动）理事单位',
    breadcrumb: '全国学校体育联盟（机器人运动）理事单位',
    icon: '',
    open: false,
    selected: false,
    disabled: false,
    typeId: 240,
    isShow: false,
  },
];
export default MenuConfig;
